import { render, staticRenderFns } from "./vehicle_map_track_fleet_fabbus.vue?vue&type=template&id=08a96af0&scoped=true&"
import script from "./vehicle_map_track_fleet_fabbus.vue?vue&type=script&lang=js&"
export * from "./vehicle_map_track_fleet_fabbus.vue?vue&type=script&lang=js&"
import style0 from "./vehicle_map_track_fleet_fabbus.vue?vue&type=style&index=0&id=08a96af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a96af0",
  null
  
)

export default component.exports